module.exports = __webpack_public_path__ + "static/media/22861482_1638425439565974_1441735651756377422_o.d4cfa056.jpg";